import Router from "@/common/router/Router";
import { Nullable } from "@/general/custom-types/CustomTypes";

export default class Routes {
  label: string;
  router: Router;
  lazyPage: Nullable<() => Promise<typeof import("*.vue")>>;
  lazyCreate: Nullable<() => Promise<typeof import("*.vue")>>;
  lazyUpdate: Nullable<() => Promise<typeof import("*.vue")>>;
  lazyShow: Nullable<() => Promise<typeof import("*.vue")>>;
  lazyList: Nullable<() => Promise<typeof import("*.vue")>>;
  //routeConfig: RouteConfig;
  routeConfig: any;

  constructor({
    router,
    lazyPage,
    lazyCreate,
    lazyUpdate,
    lazyShow,
    label,
    lazyList
  }: {
    label: string;
    router: Router;
    lazyPage?: () => Promise<typeof import("*.vue")>;
    lazyCreate?: () => Promise<typeof import("*.vue")>;
    lazyUpdate?: () => Promise<typeof import("*.vue")>;
    lazyShow?: () => Promise<typeof import("*.vue")>;
    lazyList?: () => Promise<typeof import("*.vue")>;
  }) {
    this.label = label;
    this.router = router;
    this.lazyPage = lazyPage;
    this.lazyCreate = lazyCreate;
    this.lazyUpdate = lazyUpdate;
    this.lazyShow = lazyShow;
    this.lazyList = lazyList;
    this.routeConfig = {
      path: this.router.basePath,
      component: this.lazyPage,
      label: this.label,
      icon: "mdi-view-dashboard",
      visible: true,
      meta: {
        secured: true
      },
      children: [
        {
          path: "list",
          name: this.router.listRouteName,
          label: "Lista",
          visible: true,
          component: this.lazyList,
          url: `${this.router.basePath}/list`
        },
        {
          path: "create",
          name: this.router.createRouteName,
          label: "Tworzenie",
          visible: true,
          component: this.lazyCreate,
          url: `${this.router.basePath}/create`
        },
        {
          path: ":id",
          name: this.router.showRouterName,
          label: "Szczegóły",
          visible: false,
          component: this.lazyShow,
          url: `${this.router.basePath}/:id`
        },
        {
          path: "update/:id",
          name: this.router.updateRouteName,
          label: "Edycja",
          visible: false,
          component: this.lazyUpdate,
          url: `${this.router.basePath}/update/:id`
        }
      ]
    };
  }
  addChild(childrenConfig: Record<string, unknown>) {
    this.routeConfig.children.unshift(childrenConfig);
  }
}
